import { QueryClient } from '@tanstack/react-query';
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: (count, err: any) => err?.response?.status >= 500 && count < 2, staleTime: 30_000 },
    mutations: { retry: false },
  },
});
